import { FC } from 'react';
import { WhatsAppOutlined, FacebookOutlined } from '@ant-design/icons';
import { Box } from "@mui/material";

const Questions: FC = () => {
  return (
    <div style={{
      overflowY: "auto",
      height: "100%",
    }}>
      <div
        style={{
          paddingTop: 120,
          color: "white",
          backgroundColor: "orangered",
          textAlign: "center",
          fontSize: 30,
          paddingBottom: 18,
        }}
      >
        PREGUNTAS FRECUENTES
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 20,
          marginTop: 20
        }}
      >
        <div>
          <div style={{ textAlign: "center", color: "orangered", fontSize: 20 }}>
            ¿CÓMO SE ELIGE A LOS GANADORES?
          </div>
          <div style={{ paddingLeft: 20, paddingRight: 20, textAlign: "center", fontSize: 18 }}>
            <div>
              Todos nuestros sorteos se realizan en base a la <a href="https://www.loterianacional.gob.mx/">Lotería Nacional para la Asistencia Pública mexicana.</a>
              {" "} El ganador de LA RIFA DEL TIGRE será el participante cuyo boleto coincida con las seis cifras del
              primer premio ganador de la Lotería Nacional (las fechas serán publicadas en nuestra página oficial).
            </div>
            <br />
            <div
              style={{
                color: "orangered",
                fontSize: 20,
                marginTop: 10
              }}
            >
              ¿QUÉ SUCEDE CUANDO EL NÚMERO GANADOR ES UN BOLETO NO VENDIDO?
            </div>
            <div>
              Se elige un nuevo ganador realizando la misma dinámica en otra fecha cercana (se anunciará la nueva fecha).
              Esto significa que, ¡Tendrías el doble de oportunidades de ganar con tu mismo boleto!
            </div>
            <br />

            <div
              style={{
                color: "orangered",
                fontSize: 20,
                marginTop: 10
              }}
            >
              ¿DÓNDE SE PUBLICA A LOS GANADORES?
            </div>
            <div>
              En nuestra página oficial de Facebook <a href="https://www.facebook.com/share/1Db6GwQZBX/">LA RIFA DEL TIGRE</a> puedes encontrar todos y cada uno de nuestros sorteos anteriores,
              así como las transmisiones en vivo con Lotería Nacional y las entregas de premios a los ganadores!
            </div>
            <br />
            <div
              style={{
                color: "orangered",
                fontSize: 20,
                marginTop: 10
              }}
            >
              IMPORTANTE:
            </div>
            <div>
              Fecha de Rifa del premio mayor sujeto al 80% o más de boletos vendidos.
              En caso de que no se cumpla con el mínimo de venta se pospondría durante alguna semana o semanas más respetando los boletos emitidos, apartados y vendidos.
            </div>
            <br />
            <div><b>Envíanos preguntas a</b></div>
          </div>
          <Box display="flex" justifyContent="center">
            <Box p={1} style={{ fontSize: 40 }}>
              <WhatsAppOutlined onClick={() => window.location.href = "https://wa.me/527718571117"} />
            </Box>
            <Box p={1} style={{ fontSize: 40 }}>
              <FacebookOutlined onClick={() => window.location.href = "https://www.facebook.com/share/1Db6GwQZBX/"} />
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Questions;